import FrpcConfigGenerator from './FrpcConfigGenerator';

function App() {
  return <FrpcConfigGenerator />;
}

export default App;